<template>
  <div>
    <div class="card_wraper register_wrap">
      <div class="register_title">
        <span class="title">配置服务器地址</span>
        <router-link to="/" class="go_login" replace>
          返回登录
        </router-link>
      </div>
      <div class="config_serve_info_ti_shi">
        <span>云服务器：</span>
        是指用户公共的云服务器，选择此选项时，只要保证产品及手机正常连接互联网即可。<br />
        <span>其他服务器：</span>
        是指第三方公司或个人提供部署的私有服务器，若需要使用此功能，请提前联系技术人员了解更多信息。
      </div>

      <div class="info_wrap">
        <config-hang @click.native="selectServeBtnHandle('system')" class="config_hang_server_info"
          :selectState1="selectServerState === 'system'">
          <!-- 选中和未选中状态图片 -->
          <img v-if="selectServerState === 'system'" slot="config_hang_ele1" src="~assets/img/config/xuanzhong.png"
            alt="" />
          <img v-else slot="config_hang_ele1" src="~assets/img/config/weixuan.png" alt="" />

          <span slot="config_hang_ele2">云服务器(默认)</span>
        </config-hang>

        <config-hang @click.native="selectServeBtnHandle('user')" class="config_hang_server_info"
          :selectState1="selectServerState === 'user'">
          <!-- 选中和未选中状态图片 -->
          <img v-if="selectServerState === 'user'" slot="config_hang_ele1" src="~assets/img/config/xuanzhong.png"
            alt="" />
          <img v-else slot="config_hang_ele1" src="~assets/img/config/weixuan.png" alt="" />

          <span slot="config_hang_ele2">其他服务器</span>
          <!-- img和input 配套使用 点击可以触发input的聚焦事件  v-model实际上是直接绑定的仓库数据信息 -->
          <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
          <input type="text" slot="config_hang_input_right" id="xiugaiName" placeholder="请输入服务器地址"
            v-model="userServeIp" />
        </config-hang>
      </div>

      <div class="register_btn " @click="registerSubmitHandle">确定保存</div>
    </div>
  </div>
</template>

<script>
//公用函数
import {
  countSHandle,
  checkCallphoneCrc,
  checkUserDataChangePassword
} from 'common/beforeLogin/RegisterPage'
import configHang from 'components/common/config/config-hang'
export default {
  components: {
    configHang
  },
  data() {
    return {
      userServeIp: '', ////用户设置的服务器
      selectServerState: 'system' ////默认的是云服务器  或者是user
    }
  },
  computed: {},
  methods: {
    registerSubmitHandle() {
      console.log('设置服务器的保存并返回点击了')
      console.log(this.userServeIp)
      if (this.selectServerState === 'user') {
        if (this.userServeIp === '') {
          this.$toast('其他服务器地址不能为空')
          return
        }
        localStorage.setItem('userServeIp', this.userServeIp)
      }
      localStorage.setItem('selectServerState', this.selectServerState)
      this.$showTipsToast(1, '修改成功', true)
      this.$router.replace('/')
    },
    selectServeBtnHandle(date) {
      this.selectServerState = date
      if (this.selectServerState === 'user') {
        this.userServeIp = localStorage.getItem('userServeIp')
      } else if (this.selectServerState === 'system') {
        this.userServeIp = ''
      }
    }
  },
  mounted() {
    //vue实例挂载完成，data.filter成功渲染  一般数据请求放在这里
    // this.rquestServerImgCheck() ///请求新的图片验证码
    // localStorage.getItem('userServeIp')
    this.selectServerState = localStorage.getItem('selectServerState')

    if (this.selectServerState === 'user') {
      this.userServeIp = localStorage.getItem('userServeIp')
    }
  }
}
</script>

<style>
/* 注册页面 修改密码页面  修改主账号密码页面  修改子账号密码页面共用样式 */
.config_serve_info_ti_shi {
  margin-bottom: 15px;
}

.config_serve_info_ti_shi span {
  font-weight: bold;
}

.config_hang_server_info {
  padding: 0px 0px;
}

.config_hang_server_info input {
  width: 230px;
}
</style>
